const BASIC_DIMS = [
  'analytics_filter',
  'agent_time',
  'agent_eventtype',
  'agent_agent',
  'agent_account',
  'agent_feedbacktype',
];

export const TYPE_DIMENSIONS = {
  '0': BASIC_DIMS.concat([
    'agent_application',
    'agent_attachedfile',
    'agent_device',
    'agent_dialog',
    'agent_web'
  ]),
  '1': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '2': BASIC_DIMS.concat(['agent_application']),
  '3': BASIC_DIMS.concat(['agent_application']),
  '4': BASIC_DIMS.concat(['agent_application', 'agent_web', 'agent_attachedfile']),
  '5': BASIC_DIMS.concat(['agent_application', 'agent_networkconnection']),
  '6': BASIC_DIMS.concat(['agent_application', 'agent_appinstallation']),
  '7': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '8': BASIC_DIMS.concat(['agent_application', 'agent_dialog']),
  '9': BASIC_DIMS.concat(['agent_application', 'agent_dialog']),
  '10': BASIC_DIMS.concat([
    'agent_application',
    'agent_networkconnection',
    'agent_attachedfile'
  ]),
  '11': BASIC_DIMS.concat(['agent_attachedfile']),
  '12': BASIC_DIMS,
  '13': BASIC_DIMS.concat(['agent_application']),
  '14': BASIC_DIMS.concat(['agent_device']),
  '15': BASIC_DIMS.concat(['agent_attachedfile', 'agent_device']),
  '16': BASIC_DIMS.concat([
    'agent_application',
    'agent_attachedfile',
    'agent_device'
  ]),
  '17': BASIC_DIMS,
  '18': BASIC_DIMS.concat(['agent_feedbacktype']),
  '19': BASIC_DIMS.concat(['agent_feedbacktype']),
  '20': BASIC_DIMS,
  '21': BASIC_DIMS.concat(['agent_attachedfile', 'agent_device', 'agent_application']),
  '22': BASIC_DIMS,
  '23': BASIC_DIMS.concat(['agent_device']),
  '24': BASIC_DIMS.concat(['agent_appinstallation']),
  '25': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '26': BASIC_DIMS.concat(['agent_attachedfile']),
  '27': BASIC_DIMS.concat([
    'agent_application',
    'agent_attachedfile',
    'agent_device',
    'agent_dialog',
    'agent_web'
  ]),
  '100500': BASIC_DIMS.concat(['agent_application', 'agent_web'])
};

export const isStrictDimention = (dimension, hierarchy) => {
  if (dimension === 'agent_eventtype') return true;
  // if (dimension === 'agent_agent' && hierarchy === 'computer_name') return true;
  if (dimension === 'agent_feedbacktype') return true;
  // if (dimension === 'agent_attachedfile' && hierarchy === 'file_operation') return true;
  if (dimension === 'agent_dialog' && hierarchy === 'direction') return true;
  if (dimension === 'agent_time') return true;
  return false;
};



// WEBPACK FOOTER //
// ./src/core/type-dimensions.js